import { render, staticRenderFns } from "./ActivityTable.vue?vue&type=template&id=f47edf16&scoped=true&"
import script from "./ActivityTable.vue?vue&type=script&lang=js&"
export * from "./ActivityTable.vue?vue&type=script&lang=js&"
import style0 from "./ActivityTable.vue?vue&type=style&index=0&id=f47edf16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47edf16",
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/ActivityTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fcomponents%2Fcbs-activity%2FActivityTable.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports